import { render, staticRenderFns } from "./ModelSelector.vue?vue&type=template&id=1923e63e&"
import script from "./ModelSelector.vue?vue&type=script&lang=js&"
export * from "./ModelSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports